// @ts-strict-ignore
import { getNumericPathIndices } from 'flow/service/actions/actions';
import { CaretPositionSuffixTypes } from '../NodeEditorDrawer/types';
import type { UserActionObject } from '../NodeEditorDrawer/types';
import { startingCaretPosition, ruleEditorModeToCategoryMap } from './constants';
import type { PendingParanthesisRelativeLocation } from './types';

export function getFlattenedPathInCaretPositionFormat(itemPath: string) {
  const allIndicesInPath = getNumericPathIndices(itemPath);
  return allIndicesInPath.join('-');
}

export function isCaretPositionStringOnDataRouteItem(positionString: string) {
  return positionString.endsWith(CaretPositionSuffixTypes.DATAROUTE);
}

export function isCaretPositionStringOnGroupEndParenthesis(positionString: string) {
  return positionString.endsWith(CaretPositionSuffixTypes.GROUP_END);
}

export function isCaretPositionStringOnGroupStartParenthesis(positionString: string) {
  return positionString.endsWith(CaretPositionSuffixTypes.GROUP_START);
}

export function isCaretPositionOnMLAWithoutValueOptional(positionString: string) {
  return !positionString.includes(CaretPositionSuffixTypes.MLA_VALUE_SET)
    && !positionString.includes(CaretPositionSuffixTypes.MLA_REQUIRED);
}

export function getIsCaretPositionInInitialInsertionMode(morphingCaretPosition: string) {
  return morphingCaretPosition === startingCaretPosition;
}

export function getIsCaretPositionInInsertionMode(morphingCaretPosition: string) {
  return morphingCaretPosition.endsWith(CaretPositionSuffixTypes.CARET_INSERTION);
}

export function scrubInsertionModeFromCaret(morphingCaretPosition: string) {
  return morphingCaretPosition.replace(CaretPositionSuffixTypes.CARET_INSERTION, '');
}

export function getIsCaretPositionAtEnd(
  flattenedCaretIndices: string[], morphingCaretPosition: string,
) {
  return scrubInsertionModeFromCaret(morphingCaretPosition) === flattenedCaretIndices.at(-1);
}

export function getDropdownModeCategory(mode: string): string {
  return ruleEditorModeToCategoryMap[mode] || mode;
}

export function getGroupStartIndexOffset(side: PendingParanthesisRelativeLocation) {
  return side === 'after' ? 1 : 0;
}

export function getIncrementedPositionIndex({
  userActionObject,
  indexOfCurrentCaretPositionInFlatIndices,
}: {
  userActionObject: UserActionObject;
  indexOfCurrentCaretPositionInFlatIndices: number;
}) {
  if (userActionObject.value.includes('action_')) {
    let numberToIncrement = 1;
    if (userActionObject?.value.includes('service')) {
      numberToIncrement = 2;
    }

    return String(indexOfCurrentCaretPositionInFlatIndices + numberToIncrement);
  }

  return String(indexOfCurrentCaretPositionInFlatIndices + 1);
}
